import type { SessionUser } from "../../shared/auth/access";

export function shouldNotifyProductionLoadFailure(input: {
  role: SessionUser["role"];
  terminalCode?: string;
  silent: boolean;
  blocking: boolean;
  errorCode: string | null;
}): boolean {
  return !(input.role === "URETIM_OPERATORU" && input.terminalCode && input.silent &&
    !input.blocking && ["NETWORK_ERROR", "CLIENT_REQUEST_TIMEOUT"].includes(input.errorCode ?? ""));
}

export function operatorConnectionLabel(reconnecting: boolean, loadErrorCode: string | null, lastUpdatedAt?: number | null): string | null {
  const lastData = lastUpdatedAt ? ` · Son sunucu verisi ${new Date(lastUpdatedAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}` : "";
  if (reconnecting) return "Bağlantı kontrol ediliyor · Son ölçümler korunuyor";
  if (loadErrorCode === "NETWORK_ERROR") return `Sunucudan veri alınamıyor · Son doğrulanmış veriler korunuyor${lastData}`;
  if (loadErrorCode === "CLIENT_REQUEST_TIMEOUT") return `Sunucu yanıtı gecikti · Son doğrulanmış veriler korunuyor${lastData}`;
  if (loadErrorCode) return `Sunucu verisi doğrulanamadı · Son doğrulanmış veriler korunuyor${lastData}`;
  return null;
}

/** Retain the already authenticated on-screen view only for transport/service failures.
 * An auth/assignment error must still close it; never bootstrap authority from local storage. */
export function isTransientProductionFailure(code: string | null): boolean {
  return code !== null && ["NETWORK_ERROR", "CLIENT_REQUEST_TIMEOUT", "INVALID_API_RESPONSE", "HTTP_500", "HTTP_502", "HTTP_503", "HTTP_504", "OPERATION_OUTCOME_UNKNOWN"].includes(code);
}
